import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { ShellSelectors } from '../state/shell.selectors';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngrx/store';
import { OutlookLoginService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard {

    //public readonly returnUrlToken = 'returnUrl';
    private token: string;
    private user: any;

    constructor(
        private location: Location,
        private selectors: ShellSelectors,
        private router: Router,
        private jwt: JwtHelperService,
        private outlookLogin: OutlookLoginService
    ) {
        this.selectors.token$.subscribe(x => (this.token = x));
        this.selectors.user$.subscribe(x => (this.user = x));
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const getURLParameter = (name, url = '') => {
            if (!url) {
                url = window.location.href;
            }

            return (RegExp(name + '=' + '(.+?)(&|$)').exec(url) || [, null])[1];
        }

        const url = this.location.path();

        if (!url.toLowerCase().startsWith('/callback')) {
            const token = getURLParameter('token', url);
            if (token) {
                let stateUrl = state.url;
                const index = stateUrl.indexOf('?');
                if (index >= 0) {
                    stateUrl = stateUrl.substring(0, index);
                }
                const queryParams = {
                    queryParams: {
                        token: token,
                        returnUrl: stateUrl
                    }
                };
                this.router.navigate([`/callback`], queryParams);
                return false;
            }
        }

        if (this.token && !this.jwt.isTokenExpired(this.token)) {
            if (!this.user) {
                return false;
            }
            else {
                if (this.user && (this.user.tenants && !this.user.tenants.length)) {
                    this.router.navigate(['denied']);
                    return false;
                }
            }

            return true;
        }

        this.outlookLogin.showLogin();
    }
}
